import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'
import { injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements'
import { PropTypes } from 'prop-types'
import { ZIP_REGEX, REGISTER, ROUTES_PATH, MESSAGE, SETTINGS } from '../../../constants'
import { showFlashMessage, showFlashMessageOnUnexpectedError, createSusbcription, userInfo } from 'actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import isempty from 'lodash.isempty'
import CircularProgress from '@material-ui/core/CircularProgress'
const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        fontFamily: 'Rubik',
        color: '#404552',
        fontWeight: '500',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#a9aeba',
          fontSize: '16px',
          fontWeight: 'normal',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  }
}

const styles = theme => ({
  paymentCardRow: {
    display: 'flex',
  },
  inputElement: {
    width: '100%',
    border: '0',
    outline: '0',
    fontSize: '16px',
    fontFamily: 'Rubik',
    color: '#404552',
    fontWeight: '500',
    height: '1.2em',
    '&::placeholder': {
      color: '#a9aeba',
      fontSize: '16px',
      fontWeight: 'normal',
    },
  },
  cardlabel: {
    fontSize: '13px',
    lineHeight: '1.54',
    fontWeight: 'normal',
    color: '#a9aeba',
    textTransform: 'uppercase',
    marginBottom: '6px',
  },
  paymentCardElement: {
    borderBottom: '#dee0e3 1px solid',
    paddingBottom: '8px',
  },
  paymentCardFullColumn: {
    width: '100%',
    display: 'block',
    marginBottom: '24px',
    border: '0',
    fontSize: '16px',
    fontWeight: '500',
    fontFamily: 'Rubik',
    paddingBottom: '8px',
  },
  paymentCardColumn: {
    display: 'block',
    marginBottom: '24px',
    border: '0',
    fontSize: '16px',
    fontWeight: '500',
    width: '40%',
    fontFamily: 'Rubik',
    [theme.breakpoints.down('xs')]: {
      width: '35%',
    },
    '&:nth-child(2)': {
      width: '24%',
      margin: '0 20px 24px',
      [theme.breakpoints.down('xs')]: {
        margin: '0 15px 24px',
        width: '26%',
      },
    },
    '&:nth-child(3)': {
      width: '35%',
    },
  },

  invalidMsg: {
    color: '#f44336',
    fontSize: '0.75rem',
    fontWeight: '100',
    margin: '5px 0 0',
  },
  paymentCardFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cardcancelBtn: {
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '2.63',
    letterSpacing: 'normal',
    color: '#838383',
    marginRight: '24px',
    background: 'transparent',
    border: '0',
    outline: '0',
    cursor: 'pointer',
  },
  cardsubscribeBtn: {
    height: '42px',
    padding: '10px 20px',
    borderRadius: '4px',
    backgroundColor: '#00bcb5',
    opacity: '0.8',
    fontFamily: 'Rubik',
    fontSize: '15px',
    border: '0',
    textTransform: 'uppercase',
    fontWeight: '500',
    lineHeight: '1.13',
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.8)',
    outline: '0',
    minWidth: '123px',
    cursor: 'pointer',
    '&:disabled': {
      fontWeight: '100',
      cursor: 'default',
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
  buttonProgress: {
    color: '#fff',
  },
})

const userFields = ['name', 'zip', 'cardNumber', 'cardExpiry', 'cardCvc']

class PaymentForm extends Component {
  constructor(props) {
    super(props)
    this.state = userFields.reduce((output, field) => ({ ...output, [field]: '' }), { errors: {}, loading: false })
  }

  handleSubmit = async ev => {
    ev.preventDefault()
    if (this.isValid()) {
      if (this.props.stripe) {
        this.loadingState()
        this.props.stripe.createToken({ name: this.state.name, address_zip: this.state.zip }).then(payload => {
          if (payload.token) {
            if (this.props.from === REGISTER || this.props.from === SETTINGS) {
              this.props.onTokenCreate(payload.token.id)
              this.props.onClose()
            } else {
              try {
                this.createSusbcription(payload.token.id)
              } catch (error) {
                this.loadingState()
                this.props.showFlashMessageOnUnexpectedError(error)
              }
            }
          } else if (payload.error) {
            this.loadingState()
            this.props.showFlashMessage(true, payload.error.message)
          }
        })
      } else {
        console.log("Stripe.js hasn't loaded yet.")
      }
    } else {
      console.log('invalid')
    }
  }

  createSusbcription = async token => {
    const response = await this.props.createSusbcription(token, this.props.user.token)
    if (isempty(response.errors)) {
      // server needs time to update because its running background job
      this.props.userInfo(this.props.user.token)
      this.props.onClose()
      this.props.showFlashMessage(null, MESSAGE.PREMIUM_MEMBER)
      this.props.history.push(ROUTES_PATH.HOME)
    } else {
      this.loadingState()
      this.props.showFlashMessage(true, response.errors[0])
    }
  }

  handleBlur = () => {}
  handleChange = change => {
    const element = change.elementType
    this.setState({
      [element]: 'value',
      errors: {
        ...this.state.errors,
        [element]:
          (change.error && change.error.message) ||
          (typeof change.complete !== 'undefined' && !change.complete && (typeof change.empty !== 'undefined' && change.empty) && 'is missing'),
      },
    })
  }
  handleClick = () => {}
  handleFocus = () => {}
  handleReady = () => {}

  onFormFieldChange = event => {
    const target = event.target
    const name = target.id
    const value = target.value

    this.setState(state => ({
      [name]: value,
      errors: { ...state.errors, [name]: this.validateField(name, value) },
    }))
  }

  validateField = (name, value) => {
    if (value === '') {
      return 'is missing'
    } else if (value === null || value === undefined) {
      return 'is invalid'
    }

    switch (name) {
      case 'name': {
        if ('' === value.trim()) {
          return 'is invalid'
        }
        break
      }
      case 'zip': {
        if (null === value.match(ZIP_REGEX)) {
          return 'is invalid'
        }
        break
      }
      default:
        break
    }
  }

  isValid = () => {
    return userFields.reduce((a, f) => a && this.state[f] && !this.state.errors[f], true)
  }

  loadingState = () => {
    this.setState(prevState => ({
      loading: !prevState.loading,
    }))
  }

  render() {
    const { onClose, classes, from } = this.props
    const { name, zip, errors, loading } = this.state
    return (
      <div className="checkout">
        <form onSubmit={this.handleSubmit} noValidate autoComplete="off">
          <label className={classes.paymentCardFullColumn}>
            <div className={classes.paymentCardElement}>
              <div className={classes.cardlabel}>Name on card</div>
              <input
                id="name"
                name="name"
                type="text"
                value={name}
                onChange={this.onFormFieldChange}
                className={classes.inputElement}
                placeholder=""
                required
                maxLength="120"
              />
            </div>
            <div hidden={!errors.name} className={classes.invalidMsg}>
              Please enter the Name
            </div>
          </label>
          <label className={classes.paymentCardFullColumn}>
            <div className={classes.paymentCardElement}>
              <div className={classes.cardlabel}>Card number</div>
              <CardNumberElement
                className={classes.StripeElementt}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                onFocus={this.handleFocus}
                onReady={this.handleReady}
                {...createOptions()}
              />
            </div>
            <div hidden={!errors.cardNumber} className={classes.invalidMsg}>
              {errors.cardNumber}
            </div>
          </label>
          <div className={classes.paymentCardRow}>
            <label className={classes.paymentCardColumn}>
              <div className={classes.paymentCardElement}>
                <div className={classes.cardlabel}>Expiry date</div>
                <CardExpiryElement
                  onBlur={this.handleBlur}
                  onChange={this.handleChange}
                  onFocus={this.handleFocus}
                  onReady={this.handleReady}
                  {...createOptions()}
                />
              </div>
              <div hidden={!errors.cardExpiry} className={classes.invalidMsg}>
                {errors.cardExpiry}
              </div>
            </label>
            <label className={classes.paymentCardColumn}>
              <div className={classes.paymentCardElement}>
                <div className={classes.cardlabel}>CVC</div>
                <CardCVCElement
                  onBlur={this.handleBlur}
                  onChange={this.handleChange}
                  onFocus={this.handleFocus}
                  onReady={this.handleReady}
                  {...createOptions()}
                />
              </div>
              <div hidden={!errors.cardCvc} className={classes.invalidMsg}>
                {errors.cardCvc}
              </div>
            </label>
            <label className={classes.paymentCardColumn}>
              <div className={classes.paymentCardElement}>
                <div className={classes.cardlabel}>Zip Code</div>
                <input
                  id="zip"
                  name="name"
                  type="text"
                  value={zip}
                  onChange={this.onFormFieldChange}
                  className={classes.inputElement}
                  placeholder=""
                  required
                />
              </div>
              <div hidden={!errors.zip} className={classes.invalidMsg}>
                {errors.zip}
              </div>
            </label>
          </div>
          <div className={classes.paymentCardFooter}>
            <button type="button" className={classes.cardcancelBtn} onClick={() => onClose()}>
              Cancel
            </button>
            <button type="submit" className={classes.cardsubscribeBtn} disabled={!this.isValid() || loading}>
              {loading ? <CircularProgress size={24} className={classes.buttonProgress} /> : from === SETTINGS ? 'Change' : 'Subscribe'}
            </button>
          </div>
        </form>
      </div>
    )
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showFlashMessage,
      showFlashMessageOnUnexpectedError,
      createSusbcription,
      userInfo,
    },
    dispatch
  )
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

PaymentForm.propTypes = {
  onClose: PropTypes.func,
  onTokenCreate: PropTypes.func,
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(injectStripe(PaymentForm))
)



// WEBPACK FOOTER //
// ./src/features/payment/components/PaymentForm.js